import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { filter } from 'rxjs';

import { ILegacyList, ListProperty, TableCellData, TableColumn } from '@site-mate/dashpivot-shared-library';

import { QueryStates } from 'app/shared/model/query/query-states.enum';
import { FetchedQuery } from 'app/shared/model/query/query.model';
import { SharedModule } from 'app/shared/shared.module';

import { TemplateListService } from '../../../../../apps/template-list.service';
import { ITemplateTableCell } from '../template-table-cell.interface';

export interface IListPropertyTableCellData extends TableCellData {
  content: {
    listId: string;
    columnId: string;
    propertyId?: string;
  };
}

@Component({
  selector: 'cc-template-table-list-property-cell',
  standalone: true,
  imports: [CommonModule, NgSelectModule, FormsModule, NgbModule, SharedModule, NgbModule],
  templateUrl: './template-table-list-property-cell.component.html',
  styleUrls: ['./template-table-list-property-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateTableListPropertyCellComponent implements ITemplateTableCell {
  private readonly destroyRef = inject(DestroyRef);
  private readonly templateListsService = inject(TemplateListService);
  private readonly cdr = inject(ChangeDetectorRef);
  @Input() cellData: IListPropertyTableCellData;
  @Input() tableColumns: TableColumn[];
  listName: string;
  referenceColumn: TableColumn;
  columnIndex: number;
  listProperties: ListProperty[] = [];

  ngOnInit() {
    this.fetchListsProperties();
    this.getColumnName();
  }

  private getColumnName() {
    const column = this.tableColumns.find((col) => col._id === this.cellData.content.columnId);
    this.referenceColumn = column;
  }

  private fetchListsProperties() {
    this.templateListsService
      .getFullList(this.cellData.content.listId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((query) => query.state === QueryStates.Fetched),
      )
      .subscribe((listQuery: FetchedQuery<ILegacyList>) => {
        this.listProperties = listQuery.data.properties;
        this.listName = listQuery.data.name;
        this.cdr.markForCheck();
      });
  }
}
